import React from "react";
import cn from "./helpers/cn";

interface DialogActionsProps extends React.HTMLAttributes<HTMLDivElement> {
  component?: React.ElementType;
  /** Quando true, desabilita o `flex-1 basis-auto` no primeiro item (= MUI v4). */
  disableSpacing?: boolean;
  children?: React.ReactNode;
}

const DialogActions = React.forwardRef<HTMLDivElement, DialogActionsProps>((props, ref) => {
  const {
    className,
    component: Component = "div",
    disableSpacing = false,
    children,
    ...other
  } = props;

  return (
    <Component
      ref={ref}
      className={cn(
        // MUI v4: padding 8px, flex row, justify-end, items-center, shrink-0;
        // espaçamento entre filhos (margin-left: 8px no segundo em diante).
        "flex items-center justify-end p-2 shrink-0",
        !disableSpacing && "[&>:not(:first-child)]:ml-2",
        className
      )}
      {...other}
    >
      {children}
    </Component>
  );
});

DialogActions.displayName = "DialogActions";

export default DialogActions;
